<template>
  <div :class="$style.homePage">
    <div :class="$globalStyle.headerContainer">
      <div :class="$globalStyle.header">
        <div :class="$globalStyle.headerLeft">
          <img :src="saboteurLogo" alt="icon" :class="$globalStyle.headerLogo" />
          <div :class="$globalStyle.headerTitle">{{ $t("saboteur") }}</div>
        </div>
        <div :class="$globalStyle.headerRight">
          <HeaderLanguageSelector />

          <div v-if="isLoggedIn && isStudentOnly" :class="[$globalStyle.headerButton, $style.teacherAppButton]">
            <HeaderInnerButton :text="$t('teacher-application')" :clickFunction="showTeacherApplication" buttonWidth="clamp(160px, 22vw, 220px)" />
          </div>

          <div v-if="isLoggedIn && canHostGames" :class="[$globalStyle.headerButton, $style.myGamesButton]">
            <HeaderInnerButton :text="$t('my-games')" :clickFunction="goToMyGames" buttonWidth="clamp(120px, 16vw, 160px)" />
          </div>
          
          <div :class="$style.userLogged" v-if="isLoggedIn && user?.firstName">
            <div :class="$style.userAvatar" @click="toggleUserMenu">
              <div :class="$style.userAvatarLetter">{{ user.firstName.slice(0, 1).toUpperCase() }}</div>
            </div>

            <div v-if="showUserMenu" :class="$style.userMenu">
              <div :class="$style.closeUserMenuBtn" @click="toggleUserMenu">
                <img :src="closeIcon" alt="icon" :class="$style.closeUserMenuIcon" />
              </div>
              <div :class="$style.userName">{{ user.firstName }}</div>
              <div v-if="roleOptions.length" :class="$style.rolePanel">
                <div :class="$style.rolePanelLabel">{{ $t("dashboard-current-role") }}</div>
                <div :class="$style.roleChip">{{ currentRoleLabel }}</div>
              </div>
              <div v-if="canSwitchRole" :class="$style.rolePanel">
                <div :class="$style.rolePanelLabel">{{ $t("dashboard-switch-role") }}</div>
                <div :class="$style.roleOptions">
                  <button
                    v-for="option in roleOptions"
                    :key="option.value"
                    type="button"
                    :class="[$style.roleOption, { [$style.roleOptionActive]: option.value === activeRole }]"
                    :disabled="option.value === activeRole"
                    @click="handleRoleSelect(option.value)"
                  >
                    {{ getRoleLabel(option) }}
                  </button>
                </div>
              </div>
              <div :class="$style.logoutBtn">
                <UtilButton
                  :text="$t('logout')"
                  :clickFunction="authStore.logout"
                  size="sm"
                  backBg="#A50000"
                  frontBg="#F77575"
                  textColor="#FFFFFF"
                  buttonWidth="120px"
                />
              </div>
            </div>
          </div>
          <template v-else>
            <div :class="[$globalStyle.headerButton]">
              <HeaderInnerButton :text="$t('login')" :clickFunction="handleLogin" buttonWidth="clamp(80px, 12vw, 100px)" />
            </div>
          </template>

          <!-- <button @click="handleLogin">{{ $t('login') }}</button> -->
        </div>
      </div>
    </div>
    <div :class="$style.bodyContainer">
      <div :class="$style.heroHeading">
        <h1 :class="$style.bodyText">{{ $t("description") }}</h1>
      </div>
      <div :class="$style.gameSections">
        <div v-if="canHostGames" :class="[$style.gameSectionBox, $style.hostGameBox]">
          <div :class="$style.gameSectionTitle">
            <img :src="hostGameIcon" alt="Host Game" :class="$style.icon" />
            <div :class="$style.gameSectionTitleText">{{ $t("hosting") }}</div>
          </div>
          <div :class="$style.gameSectionText">
            {{ $t("hosting-description") }}
          </div>
          <div :class="$style.gameSectionCta">
            <ActionButton
              :text="$t('create')"
              :clickFunction="createGame"
              backBg="#112d4e"
              textColor="#112d4e"
              buttonWidth="72%"
            />
          </div>
        </div>
        <div :class="[$style.gameSectionBox, $style.joinGameBox]">
          <div :class="$style.gameSectionTitle">
            <img :src="joinGameIcon" alt="Join Game" :class="$style.icon" />
            <div :class="$style.gameSectionTitleText">{{ $t("join") }}</div>
          </div>
          <div :class="$style.gameSectionText">
            {{ $t("join-description") }}
          </div>
          <div :class="$style.gameSectionCta">
            <ActionButton
              :text="$t('join-game')"
              :clickFunction="joinGame"
              backBg="#A14000"
              textColor="#A14000"
              buttonWidth="72%"
            />
          </div>
        </div>
        <!-- <div :class="[$style.gameSectionBox, $style.hostGameBox]">
          <div :class="$style.gameSectionTitle">
            <img :src="copyGameIcon" alt="Host Game" :class="$style.icon" />
            <div :class="$style.gameSectionTitleText">{{ $t('copy') }}</div>
          </div>
          <div :class="$style.gameSectionText">
            {{ $t('copy-description') }}
          </div>
          <div :class="$style.gameSectionCta">
            <div :class="$style.ctaButton">
              <UtilButton text="Copy Game" :clickFunction="copygame" />
            </div>
          </div>
        </div> -->
      </div>
      <div v-if="canHostGames" :class="$style.gameSections2">
        <div :class="$style.copyGameBox">
          <div :class="$style.copyGameBoxtext">
            {{ $t("copy-description") }}
          </div>
          <div :class="$style.copyGameBoxCtaContainer">
            <ActionButton
              :text="$t('copy')"
              :clickFunction="copygame"
              backBg="#000000"
              frontBg="#676767"
              textColor="#FFFFFF"
              buttonWidth="clamp(194px, 20vw, 240px)"
            />
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.footerContainer">
      <!-- <div :class="$style.footer">&copy; 2024 TTG. All rights reserved.</div> -->
      <!-- <div :class="$style.footer">Copyright 2025, Dr. Glenn Gordon Smith & IMapBook, LLC</div> -->
      <div :class="$style.footer">&copy; 2025, Dr. Glenn Gordon Smith & IMapBook, LLC</div>
    </div>
    <ExploreGamesLauncher />
  </div>
</template>

<script>
import styles from "../css/HomeView.module.css";
import globalStyles from "@/css/global.module.css";
import SaboteurLogo from "../assets/saboteur-logo.svg";
import HostGameIcon from "../assets/icons/host-game.svg";
import JoinGameIcon from "../assets/icons/join-game.svg";
import CopyGameIcon from "@/assets/icons/copy-white.svg";
import CloseIcon from "@/assets/icons/close-red.svg";
import UtilButton from "@/components/util/UtilButton.vue";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/authStore";
import HeaderLanguageSelector from "@/components/util/HeaderLanguageSelector.vue";
import HeaderInnerButton from "@/components/buttons/HeaderInnerButton.vue";
import ActionButton from "@/components/buttons/ActionButton.vue";
import ExploreGamesLauncher from "@/components/explore/ExploreGamesLauncher.vue";
import { USER_ROLES, canAssumeRole, getRoleContext, getRoleRoute, getRoleSelectorOptions } from "@/utils/permissions";

export default {
  name: "HomeView",
  components: { UtilButton, HeaderInnerButton, ActionButton, HeaderLanguageSelector, ExploreGamesLauncher },
  data() {
    return {
      saboteurLogo: SaboteurLogo,
      hostGameIcon: HostGameIcon,
      joinGameIcon: JoinGameIcon,
      copyGameIcon: CopyGameIcon,
      closeIcon: CloseIcon,
      showUserMenu: false,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $globalStyle() {
      return globalStyles;
    },
    roleOptions() {
      return getRoleSelectorOptions(this.user);
    },
    activeRole() {
      return this.authStore.activeRole || getRoleContext(this.user);
    },
    canSwitchRole() {
      return this.roleOptions.length > 1;
    },
    currentRoleLabel() {
      const currentOption = this.roleOptions.find((option) => option.value === this.activeRole);
      if (currentOption) return this.getRoleLabel(currentOption);
      return this.activeRole || "";
    },
    canHostGames() {
      return canAssumeRole(this.user, USER_ROLES.TEACHER);
    },
    isStudentOnly() {
      return this.isLoggedIn && this.roleOptions.length === 0;
    },
  },
  methods: {
    createGame() {
      // console.log("Create game clicked");
      // this.$router.push({ name: "create-game", params: { userId: 123 } });
      this.$router.push({ name: "create-game", params: {} });
    },
    joinGame() {
      // console.log("Join game clicked");
      this.$router.push({ name: "join-game", params: {} });
    },
    copygame() {
      // console.log("Copy game clicked");
      this.$router.push({ name: "load-game", params: {} });
    },
    handleLogin() {
      // this.authStore.showAuthModal("signup");
      this.authStore.showAuthModal();
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    showTeacherApplication() {
      this.$router.push({ name: "teacher-application" });
    },
    goToMyGames() {
      this.$router.push({ name: "teacher" });
    },
    getRoleLabel(option) {
      if (option?.labelKey) return this.$t(option.labelKey);
      return option?.label || option?.value || "";
    },
    handleRoleChange(nextRole) {
      this.authStore.setActiveRole(nextRole);
      this.$router.push(getRoleRoute(nextRole));
    },
    handleRoleSelect(nextRole) {
      if (!nextRole || nextRole === this.activeRole) return;
      this.handleRoleChange(nextRole);
      this.showUserMenu = false;
    },
  },
  setup() {
    const authStore = useAuthStore();
    const { isLoggedIn, user } = storeToRefs(authStore);

    return {
      authStore,
      isLoggedIn,
      user,
    };
  },
};
</script>
